import { observer } from 'mobx-react';
import { StandardDialog, Tabs } from '@roc/ui';
import { useDrawsStore } from '../hooks';
import { DrawReviewReportShared } from '../drawReviewReport/components/drawReviewReportShared';
import { Document } from '@roc/feature-types';
import { useState } from 'react';
import { Box } from '@material-ui/core';
import { InspectionReport } from '@roc/feature-inspections';
import { makeStyles } from '@material-ui/core/styles';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

interface DrawReportDialogProps {
  open: boolean;
  onClose: () => void;
  document: Document;
}

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialogContent-root': {
      height: 'calc(90vh - 64px)',
    },
  },
}));

export const DrawReportDialog = observer(
  ({ open, onClose, document }: DrawReportDialogProps) => {
    const { drawReviewReportStore } = useDrawsStore();
    const classes = useStyles();
    const hasInspectionId = !!drawReviewReportStore.inspectionId;
    const taskId = document?.taskId;

    return (
      <>
        {taskId ? (
          <CustomTaskDialog
            open={open}
            title="Draw Report"
            maxWidth={hasInspectionId ? false : 'xl'}
            className={hasInspectionId ? classes.dialog : undefined}
            handleClose={onClose}
            removeContentBox
            dialogContent={
              <DrawReviewReportShared
                store={drawReviewReportStore}
                isInternal={false}
                drawId={document?.drawId}
              />
            }
            taskId={taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Draw Report"
            maxWidth={hasInspectionId ? false : 'xl'}
            className={hasInspectionId ? classes.dialog : undefined}
            handleClose={onClose}
            removeContentBox
            dialogContent={
              <DrawReviewReportShared
                store={drawReviewReportStore}
                isInternal={false}
                drawId={document?.drawId}
              />
            }
          />
        )}
      </>
    );
  }
);
